<span class="cell-ecart">
  <span [className]="_ecart > 0 ? 'positive' : _ecart < 0 ? 'negative' : ''">{{signedEcart}}</span>
</span>
